<template>
  <div>
    <BaseFrame
      :infosArr="infosArr"
      :id="curingReCheck.code"
      idText="复查单号">
      <div slot="content">
        <lk-card title="复查结果信息">
          <lk-table border :columns="columns" :data="tableData"></lk-table>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame';
import inventory from '../../services/inventory';
import CuringReCheckExpand from './CuringReCheckExpand.vue';
import utils from '../../libs/utils';

export default {
  components: {
    BaseFrame,
  },
  data() {
    return {
      infosArr: [],
      curingReCheck: {},
      columns: [
        {
          type: 'expand',
          width: 46,
          render: (h, { row }) => h(CuringReCheckExpand,
            {
              props: {
                row,
              },
            }),
        },
        {
          title: '商品编码',
          key: 'drugSerialCode',
          minWidth: 110,
        },
        {
          title: '通用名称',
          key: 'approvedDrugNames',
          minWidth: 110,
        },
        {
          title: '仓库',
          key: 'warehouseName',
          minWidth: 110,
        },
        {
          title: '货位',
          key: 'locationCode',
          minWidth: 110,
        },
        {
          title: '批号',
          key: 'goodsBatchNumber',
          minWidth: 110,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 110,
        },
        {
          title: '存疑数量',
          key: 'doubtfulCount',
          minWidth: 110,
        },
        {
          title: '备注',
          key: 'description',
          minWidth: 110,
        },
        {
          title: '正常数量',
          key: 'normalCount',
          minWidth: 110,
        },
        {
          title: '养护措施',
          key: 'curingMeasuresStr',
          minWidth: 110,
        },
        {
          title: '处理结果',
          key: 'normalResults',
          minWidth: 110,
        },
        {
          title: '异常数量',
          key: 'abnormalCount',
          minWidth: 110,
        },
        {
          title: '处理结果',
          key: 'banResults',
          minWidth: 110,
        },
        {
          title: '复查备注',
          key: 'reCheckDescription',
          minWidth: 110,
        },
        {
          title: '商品类型',
          key: 'goodsTypeName',
          minWidth: 110,
        },
        {
          title: '来源',
          key: 'purchaseTypeName',
          minWidth: 110,
        },
      ],
      tableData: [],
    };
  },
  computed: {},
  methods: {
    getData() {
      inventory.getCuringReCheckById({ id: Number.parseInt(this.$route.params.id) }).then((res) => {
        if (res.data.status === 200) {
          const { curingReCheck, curingRecheckDetailVoList } = res.data.data;
          this.tableData = [];
          curingRecheckDetailVoList.forEach((item) => {
            const result = item.curingReCheckRecord;
            result.goodsType = item.goodsType;
            result.goodsTypeName = item.goodsTypeName;
            result.normalResults = '允许销售';
            result.banResults = '禁止销售';
            this.tableData.push(result);
          });
          this.infosArr = [
            {
              name: '养护人:',
              value: curingReCheck.createUserName,
            },
            {
              name: '养护时间:',
              value: utils.exchangeTime(curingReCheck.createTime),
            },
            {
              name: '养护详情:',
              value: '部分商品存在异常情况，需要进行确认',
            },
          ];
          this.curingReCheck = curingReCheck;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
</style>
